import { component } from 'picoapp';

export default component((node) => {
  const trigger = node.querySelector('[data-edit-target]');
  const { editTarget } = trigger.dataset;

  trigger.addEventListener('click', (e) => {
    e.preventDefault();

    document.dispatchEvent(new CustomEvent('edit:toggle', {
      detail: { key: editTarget },
    }));
  });
});
